import _ from 'lodash';

$(document).on('ready turbolinks:load', () => {
  $('form.edit_settings .holidays-list .list-item')
    .find('.btn-row-actions.btn-edit').off('click').on('click', ({ currentTarget }) => {
      const $li = $(currentTarget).parents('.list-item').addClass('edit-mode');
      $li.find('.item-name').text($li.find('input').filter((i, input) => _.endsWith(input.id, 'name')).val());
      $li.find('.item-start').text($li.find('input').filter((i, input) => _.endsWith(input.id, 'start_date')).val());
      $li.find('.item-end').text($li.find('input').filter((i, input) => _.endsWith(input.id, 'end_date')).val());
    });
});
